import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatanotService } from "./matanot.service";
import { IMatana } from "./matana";
import { IMatanotUserDetails } from "./user-details";
import { IRishumMatana } from "./rishum-matana";
import { IEzorChaluka } from "./ezor-chaluka";
import { CustomValidators } from 'ng2-validation';

@Component({
    moduleId: module.id,
    templateUrl: './matanot.component.html',
    styleUrls: ['./matanot.component.css'],
    providers: [MatanotService],
    selector: 'matanot'
})

export class MatanotComponent implements OnInit {
    rishum: FormGroup;
    matanot: IMatana[];
    user: IMatanotUserDetails;
    ezor_chaluka: IEzorChaluka[];
    errorMessage: string;
    is_submited: boolean = false;
    isvalidform: boolean = true;
    revealExternalCompanyLink : boolean = false;

    constructor(private _matanotService: MatanotService, private router: Router, private fb: FormBuilder) { }

    ngOnInit(): void {

        this.revealExternalCompanyLink = true;
        this.rishum = this.fb.group({
            phone: ['', [Validators.required, Validators.pattern('^[0][5][0-9]{8}$')]],
            email: ['', [CustomValidators.email]],
            k_sug_matana: ['', [Validators.required, CustomValidators.gt(0)]],
            k_m_chaluka: ['', [Validators.required, CustomValidators.gt(0)]]
        });

        
        console.log(this.rishum)
        this._matanotService.getUserMatanot()
            .subscribe(u => {
                this.user = u;
                this.rishum.patchValue(u);
                this.rishum.patchValue({"k_sug_matana":1});
                
            },
            error => {
                debugger
                if (error.includes("401")) {
                    localStorage.removeItem("token");
                    location.reload();
                } else if (error.includes("400")) {
                    this.router.navigateByUrl('/matanot/rishum-expired');
                }
                else {
                    this.isvalidform = false;
                    this.errorMessage = error;
                }
            })

        this._matanotService.getMatanot()
            .subscribe(m => { this.matanot = m; console.log('matanot',this.matanot)},
            error => {
                debugger;
                if (error.includes("401")) {
                    localStorage.removeItem("token");
                    location.reload();
                } else if (error.includes("400")) {
                    this.router.navigateByUrl('/matanot/rishum-expired');
                }
                else {
                    this.isvalidform = false;
                    this.errorMessage = error;
                }
            })

        this._matanotService.getMatanaEzorChaluka()
            .subscribe(m => { this.ezor_chaluka = m },
            error => {
                debugger;
                if (error.includes("401")) {
                    localStorage.removeItem("token");
                    location.reload();
                } else if (error.includes("400")) {
                    this.router.navigateByUrl('/matanot/rishum-expired');
                }
                else {
                    this.isvalidform = false;
                    this.errorMessage = error;
                }
            })
    }

    onSubmit(event, { value, valid }: { value: IRishumMatana, valid: boolean }) {
        event.preventDefault();
        this.is_submited = true;
        if (valid) {
            this._matanotService.saveRishumMatana(value)
                .subscribe(r => {
                    if (r.status) {
                        this.router.navigate(['matanot', 'endrishum']);
                    }

                    this.isvalidform = false;
                    this.is_submited = false;
                    this.errorMessage = r.returnMessage;
                },
                error => {
                    
                    if (error.includes("401")) {
                        localStorage.removeItem("token");
                        location.reload();
                    }

                    this.isvalidform = false;
                    this.errorMessage = error;
                    this.is_submited = false;
                });
        }
    }

    back(event) {
        event.preventDefault();
        localStorage.removeItem("token");
        location.reload();
    }
}